/**
 * Centinela compartido con el backend para representar un bloqueo
 * definitivo del seller en `pipedrive_sellers_status.until_date`.
 *
 * El motor de scoring y el snapshot_builder leen esta fecha tal cual:
 * cuando coincide con el centinela, el panel marca al seller como
 * "Bloqueado" (status definitivo) y apaga `active_flag` para excluirlo
 * de la cola de asignacion. Cualquier otra fecha en el futuro se trata
 * como ausencia temporal (vacaciones, incapacidad, permisos, etc.).
 *
 * Se manda explicitamente desde el front (en lugar de `null`) para que
 * el patch sea valido tanto contra el backend nuevo (tolera ausencia)
 * como contra el viejo (exige fecha en `state == 'inactivo'`).
 */
export const PERMANENT_BLOCK_UNTIL = '9999-12-31';
